"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Layers: function() {
        return Layers;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Layers = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7C22 7.36317 21.8031 7.69779 21.4856 7.87416L18.5591 9.5L21.4856 11.1258C21.8031 11.3022 22 11.6368 22 12C22 12.3632 21.8031 12.6978 21.4856 12.8742L18.5591 14.5L21.4856 16.1258C21.8031 16.3022 22 16.6368 22 17C22 17.3632 21.8031 17.6978 21.4856 17.8742L12.4856 22.8742C12.1836 23.0419 11.8164 23.0419 11.5144 22.8742L2.51436 17.8742C2.19689 17.6978 2 17.3632 2 17C2 16.6368 2.19689 16.3022 2.51436 16.1258L5.44087 14.5L2.51436 12.8742C2.19689 12.6978 2 12.3632 2 12C2 11.6368 2.19689 11.3022 2.51436 11.1258L5.44087 9.5L2.51436 7.87416C2.19689 7.69779 2 7.36317 2 7C2 6.63683 2.19689 6.30221 2.51436 6.12584L11.5144 1.12584ZM8.00088 8.63431C7.99135 8.62881 7.98175 8.62347 7.97207 8.6183L5.05913 7L12 3.14396L18.9409 7L16.0279 8.61831C16.0182 8.62348 16.0087 8.62881 15.9991 8.6343L12 10.856L8.00088 8.63431ZM7.5 10.644L5.05913 12L7.97205 13.6183C7.98175 13.6235 7.99136 13.6288 8.00089 13.6343L12 15.856L15.9991 13.6343C16.0086 13.6288 16.0183 13.6235 16.0279 13.6183L18.9409 12L16.5 10.644L12.4856 12.8742C12.1836 13.0419 11.8164 13.0419 11.5144 12.8742L7.5 10.644ZM16.5 15.644L12.4856 17.8742C12.1836 18.0419 11.8164 18.0419 11.5144 17.8742L7.5 15.644L5.05913 17L12 20.856L18.9409 17L16.5 15.644Z",
        fill: "currentColor"
    })
}), "Layers");
const _default = Layers;
